/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectChangeOrderDetailsCommand } from '../../models/create-project-change-order-details-command';
import { CreateProjectChangeOrderDetailsCommandResult } from '../../models/create-project-change-order-details-command-result';

export interface ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Params {
      body?: CreateProjectChangeOrderDetailsCommand
}

export function apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>;
    })
  );
}

apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain.PATH = '/api/ProjectChangeOrder/CreateProjectChangeOrderDetails';
